import { Img } from "container/Manual/components/content/Image";
import { Paragraph } from "container/Manual/components/content/Paragraph";
import { Li } from "container/Manual/components/list/Li";
import { Ul } from "container/Manual/components/list/Ul";
import { CardSection } from "container/Manual/components/section/CardSection";
import { ListSection } from "container/Manual/components/section/ListSection";

export const DATETRUNC = () => {
  return (
    <CardSection id="DATETRUNC" title="DATETRUNC">
      <Paragraph>
        날짜/시간 타입의 데이터를 주어진 기준으로 잘라내 불필요한 세부 정보를
        제거합니다. SQL DATE_TRUNC() 함수와 동일한 출력을 제공합니다.
      </Paragraph>

      <ListSection title="Syntax">
        <Paragraph accent>DATETRUNC(DATETIME, TIMESTAMP)</Paragraph>
        <Ul>
          <Li>
            <b>DATETIME</b>는 변환하려는 날짜입니다.
          </Li>
          <Li>
            <b>TIMESTAMP</b>는 날짜/시간을 자를 기준이 되는 단위입니다. 다음은{" "}
            <b>TIMESTAMP</b>에 대해 인식되는 값 목록입니다.
            <Ul>
              <Li>Years</Li>
              <Li>Months</Li>
              <Li>Weeks</Li>
              <Li>Days</Li>
              <Li>Hours</Li>
              <Li>Minutes</Li>
              <Li>Seconds</Li>
            </Ul>
          </Li>
        </Ul>
      </ListSection>

      <ListSection title="Example">
        <Paragraph accent>DATETRUNC(`order_timestamp`, "hours")</Paragraph>
        <Img src="computeDatetrunc" />
      </ListSection>

      <ListSection title="Notes on use">
        <Paragraph>
          제공하는 <b>DATETIME</b>은 날짜/시간 객체 혹은 날짜/시간 객체를
          포함하는 열 또는 날짜/시간 객체를 반환하는 함수여야 합니다.
        </Paragraph>
      </ListSection>
    </CardSection>
  );
};
